// eslint-disable-next-line import/prefer-default-export
export const forceProfileRedirect = (last_updated) =>
  last_updated < new Date().setFullYear(new Date().getFullYear() - 1)

/**
 * Checks if the current environment is localhost
 * @returns {boolean} True if running on localhost, false otherwise
 */
export const isLocalhost = () => {
  return Boolean(window.location.hostname.includes("localhost"))
}
